import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { MedigiComponentCopyService } from '../medigi-component-copy.service';

@Component({
  selector: 'app-medigi-pharamacy-info',
  templateUrl: './pharamacy-info.component.html',
  styleUrls: ['./pharamacy-info.component.scss'],
})
export class MedigiPharamacyInfoComponent implements OnInit {
  quoteCards;
  showFirstImage = true;
  showSecondImage = false;

  constructor(
    private medigiCopyService: MedigiComponentCopyService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  ngOnInit() {
    this.getCardInfo();
  }

  getCardInfo() {
    this.quoteCards = this.medigiCopyService.cards.largeCard.generalQuotes;
  }

  handleImageCarousel(index) {
    if (index === 1) {
      this.showFirstImage = true;
      this.showSecondImage = false;
    } else if (index === 2) {
      this.showFirstImage = false;
      this.showSecondImage = true;
    }
  }

  openPDF() {
    window.open('/assets/docs/Pharmacy-Page-Download_F.pdf', '_blank');
  }

  sendToGa(eventName, eventCategory) {
    this.googleAnalyticsService.eventEmitter(eventCategory, eventName);
  }
}
